export default "__VITE_ASSET__cec0f107__"